import { NotificationType } from "./enums";

export const NOTIFICATION_STORE_NAME = "notification";

export const NOTIFICATION_TYPE_TO_PRIME_SEVERITY: Record<NotificationType, string> = {
  [NotificationType.SUCCESS]: "success",
  [NotificationType.ERROR]: "error",
  [NotificationType.WARNING]: "warn",
  [NotificationType.DEFAULT]: "info",
};

export function getNotificationTypeMessage(type: NotificationType): string {
  const messages: Record<NotificationType, string> = {
    [NotificationType.WARNING]: $localize`:@@notification-module|summary|warning:WARNING`,
    [NotificationType.ERROR]: $localize`:@@notification-module|summary|error:ERROR`,
    [NotificationType.SUCCESS]: $localize`:@@notification-module|summary|success:Success`,
    [NotificationType.DEFAULT]: $localize`:@@notification-module|summary|info:Info`,
  };
  return messages[type];
}

export const NOTIFICATION_TYPE_TO_ICON: Record<NotificationType, string> = {
  [NotificationType.SUCCESS]: "pi-check",
  [NotificationType.ERROR]: "pi-times-circle",
  [NotificationType.WARNING]: "pi-exclamation-triangle",
  [NotificationType.DEFAULT]: "pi-info-circle",
};
